// Arrays add up their length; a group of scalars (a from/to range, a
// single-select) counts as one value.
export const countFilterValues = (values: unknown[]): number => {
  const arrays = values.filter(Array.isArray);

  if (arrays.length > 0) {
    return arrays.reduce((total, array) => total + array.length, 0);
  }

  return values.some(Boolean) ? 1 : 0;
};
